import { request } from "bwip-js";

export default {
  latitude: "latitud",
  longitude: "longitud",
  startsWith: "Empieza con",
  contains: "Contiene",
  notContains: "No incluye",
  endsWith: "Termina con",
  equals: "igual",
  notEquals: "no es igual",
  noFilter: "Sin filtro",
  lt: "Menos que",
  lte: "Menos que o igual a",
  gt: "Mayor que",
  gte: "Mayor qué o igual a",
  dateIs: "Fecha es",
  dateIsNot: "Fecha no es",
  dateBefore: "La fecha es antes",
  dateAfter: "La fecha es despues",
  clear: "Limpiar",
  apply: "Aplicar",
  matchAll: "Coincidir con todo",
  matchAny: "Coincide con cualquiera",
  addRule: "Añadir Regla",
  removeRule: "Quitar Regla",
  accept: "Sí",
  reject: "No",
  choose: "Escoger",
  upload: "Subir",
  cancel: "Cancelar",
  dayNames: [
    "Domingo",
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado",
  ],
  dayNamesShort: ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"],
  dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
  monthNames: [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ],
  monthNamesShort: [
    "Ene",
    "Feb",
    "Mar",
    "Abr",
    "May",
    "Jun",
    "Jul",
    "Ago",
    "Sep",
    "Oct",
    "Nov",
    "Dic",
  ],
  today: "Hoy",
  weekHeader: "Semana",
  firstDayOfWeek: 1,
  dateFormat: "dd-mm-yy",
  weak: "Débil",
  medium: "Mediano",
  strong: "Fuerte",
  passwordPrompt: "Introduce una contraseña",
  emptyFilterMessage: "No se han encontrado resultados",
  emptyMessage: "Sin opciones disponibles",
  uploadedFiles: "Uploaded files",
  uploadFailed: "Upload Failed",
  maxFileLimit: "Max file limit of ${limit} exceeded!",
  assignBoxOrContainer: "Asignar caja o contenedor",
  loadingCandidates: "Cargando candidatos...",
  selectCandidate: "Seleccionar",
  useContainerInstead: "Usar contenedor en su lugar",
  containerIdentifierPlaceholder: "Ej. CONT-12345",
  noCandidatesFoundModal:
    "No se encontraron solicitudes/cajas que cumplan la condición.",
  confirm: "Confirmar",
  aria: {
    trueLabel: "Verdadero",
    falseLabel: "Falso",
    nullLabel: "No seleccionado",
    slideNumber: "Diapositiva {slideNumber}",
    pageLabel: "PûÀgina",
    firstPageLabel: "Primera PûÀgina",
    lastPageLabel: "û?ltima PûÀgina",
    nextPageLabel: "PûÀgina Siguiente",
    previousPageLabel: "PûÀgina Anterior",
    selectLabel: "Seleccione",
    unselectLabel: "Deseleccionar",
    expandLabel: "Expandir",
    collapseLabel: "Contraer",
  },
  validations: {
    required: "El valor es requerido.",
    undefined: "El valor es requerido.",
    email: "El valor no es una dirección de correo electrónico válida",
    minLength: "Este campo debe tener al menos ${min} caracteres",
    maxLength: "La longitud máxima permitida es ${max}",
    minValue: "El valor mínimo permitido es ${min}",
    maxValue: "El valor máximo permitido es ${max}",
    numeric: "El valor debe ser numérico",
    ipAddress: "El valor no es una dirección IP válida",
    sameAs: "El valor debe ser igual al valor de ${otherName}",
    alpha: "El valor solo debe contener letras",
    alphaNum: "El valor solo debe contener letras y números",
    between: "El valor debe estar entre ${min} y ${max}",
    length: "La longitud debe ser de ${length} caracteres",
    pattern: "El valor no cumple con el formato requerido",
    url: "El valor no es una URL válida",
    integer: "El valor debe ser un número entero",
    minItems: "Debe seleccionar al menos ${min} elementos",
    maxItems: "No puede seleccionar más de ${max} elementos",
  },
  company: "Compañía",
  company_name: "Nombre de la compañía",
  visitant: "Visitante",
  visitant_name: "Nombre del visitante",
  visitante_name: "Nombre del visitante",
  visitant_email: "Correo electrónico del visitante",
  visitant_phone: "Teléfono del visitante",
  phone: "Teléfono",
  reason: "Razón",
  visit_to: "Visita a",
  select_to: "Seleccionar a quién visitará",
  date_to_visit: "Fecha de visita",
  time_to_visit: "Hora de visita",
  identification: "Identificación",
  officialIdentification: "Número de identificación oficial",
  Indentifications: "(INE, Licencia de conducir, Pasaporte)",
  Indentifications2: "(Licencia de Conducir, Pasaporte)",
  fmmNumber: "Número FMM",
  fmmNumberPlaceholder:
    "Ingresa el numero de identificación oficial (Licencia de conducir, Pasaporte)",
  fmmFormatExample: "Formato: 9-15 caracteres alfanuméricos",
  fmmRequired:
    "El número de identificación oficial es obligatorio para extranjeros",
  fmmRequiredToAccess:
    "Se requiere identificación oficial para el acceso de extranjeros",
  ineRequiredToAccess: "Se requiere identificación para ciudadanos mexicanos",
  ineNumberPlaceholder: "Ingresa el número de identificación oficial",
  ineFormatExample: "13 dígitos numéricos",
  ineRequired: "El INE es obligatorio para ciudadanos mexicanos",
  seeFmmExample: "Ver ejemplo de numero de identificación oficial",
  fmmExampleTitle: "Ejemplo de numero de identificación oficial",
  fmmHelp:
    "Estos son los documentos de identificación oficial aceptados para extranjeros:",
  fmmExampleAlt: "Ejemplo de FMM mexicano",
  fmmTooltipText:
    "Localiza el número de tu documento de identificación oficial",
  validationError: "Error de validación",
  identificationHelp:
    "Aquí puedes ver un ejemplo de dónde encontrar tu número de identificación oficial:",
  imageNotAvailable: "Imagen no disponible",
  identificationExampleTitle: "Ejemplo de Identificación Oficial",
  identificationExampleAlt: "Ejemplo de Identificación Oficial INE",
  imageNotAvailable: "Imagen no disponible",
  ineTooltipText:
    "INE: Ingresa los 13 dígitos que aparecen en la parte inferior de tu credencial.",
  seeIdentificationExample: "Ver ejemplo de identificación oficial",
  idIneLabel: "INE - Credencial para Votar",
  idIneAlt: "Ejemplo de INE - Frente",
  idDriverLicenseLabel: "Licencia de Conducir",
  idDriverLicenseAlt: "Ejemplo de Licencia de Conducir",
  idPassportLabel: "Pasaporte",
  idPassportAlt: "Ejemplo de Pasaporte",
  fmmCardLabel: "Pasaporte - Frente",
  fmmCardAlt: "Ejemplo de Pasaporte - Frente",
  fmmVisaLabel: "Licencia de Conducir - Frente",
  fmmVisaAlt: "Ejemplo de Licencia de Conducir - Frente",
  fmmDocumentLabel: "Documento Migratorio FMM",
  fmmDocumentAlt: "Ejemplo de Documento Migratorio FMM",
  save: "Guardar",
  submit: "Enviar",
  info_not_permitted:
    "Este acceso es exclusivamente para visitas. Queda estrictamente prohibido realizar actividades operativas, tales como obras, construcción, mantenimiento o entrega de materiales bajo este tipo de permiso",
  show_security_rules: "Mostrar normas de seguridad",
  employees: "Empleados",
  visitors: "Visitantes",
  carriers: "Transportistas",
  carriersDashboard: "Dashboard operativo de transportistas",
  dashboard: "Dashboard",
  carrierOperations: "Operaciones",
  carrierCatalogs: "Catálogos",
  carrierLogs: "Bitácoras",
  carrierMap: "Patio de Maniobras",
  carriersMap: "Patio de Maniobras",
  carriersDashboardLabels: {
    title: "Dashboard operativo de transportistas",
    todayLabel: 'Hoy "Fecha: ${date}"',
    rangeCurrent: "Rango actual: ${range}",
    rangeLabel: "Ver por",
    dateRangeLabel: "Rango de fechas",
    apply: "Aplicar",
    clear: "Limpiar",
    viewList: "Ver listado",
    driverIngressTitle: "Ingreso de Choferes",
    visitsTitle: "Visitas Transportistas",
    avgInspectionTitle: "Tiempos Promedio de Inspecciones",
    emptyChart: "Sin datos para el rango seleccionado",
    emptyVisits: "Sin visitas registradas",
    emptyTable: "No se encontraron registros para los filtros seleccionados.",
    range: {
      day: "Dia",
      week: "Semana",
      month: "Mes",
      year: "Año",
    },
    legend: {
      export: "Expo",
      import: "Impos",
      empty: "Vacios",
      return: "Retornos",
    },
    summary: {
      requests: "Solicitudes en Carrier",
      exports: "Exportaciones en Proceso",
      locals: "Locales en Proceso",
      imports: "Importaciones en Proceso",
      returns: "Retornos en Proceso",
    },
    inspections: {
      done: "Inspecciones Realizadas",
      locals: "Locales",
      backups: "Respaldos",
      returns: "Retornos",
      exports: "Exportaciones",
      imports: "Importaciones",
      secondReview: "Segunda Revision",
      rejected: "Inspecciones Rechazadas",
    },
    drivers: {
      local: "Choferes Locales",
      impoExpo: "Choferes Impo/Expo",
      binational: "Choferes Binacionales",
      mechanics: "Mecanicos",
      hazmat: "Manejadores de Material y/o Residuo Peligroso",
    },
    filters: {
      dateFrom: "Salida - Desde",
      dateTo: "Salida - Hasta",
      movementType: "Tipo de movimiento",
      carrierCompany: "Empresa Transportista",
      unitOrDriver: "Unidad o chofer",
      unitOrDriverPlaceholder: "Buscar por unidad o chofer",
    },
  },
  welcomeTitle: "¡BIENVENIDOS!",
  welcomeMessage: "Mensaje de bienvenida",
  securityRules: "Normas de seguridad",
  securityRulesTitle: "NORMAS GENERALES DE SEGURIDAD, HIGIENE Y MEDIO AMBIENTE",
  securityRule1:
    "Está Prohibido fumar dentro de la planta. Solo es permitido fumar en el exterior de planta en el área designada",
  securityRule2:
    "Portar una identificación visible todo el tiempo dentro de las instalaciones.",
  securityRule3:
    "Prohibido ingresar bajo la influencia de alcohol, estupefacientes o cualquier sustancia que altere las facultades mentales o sensoriales.",
  securityRule4:
    "No tomar fotografías o videos dentro de las instalaciones sin autorización de HSE o RH.",
  securityRule5:
    "Prohibido sustraer herramientas, materiales o equipo sin autorización.",
  securityRule6: "Respetar y obedecer todos los señalamientos de seguridad.",
  securityRule7:
    "El equipo de protección personal (EPP) mínimo es: zapato de seguridad, lentes de seguridad, tapones auditivos, chaleco con reflejante (contratistas / proveedores / visitas). Puede requerirse EPP adicional dependiendo del tipo de trabajo.",
  securityRule8: "No se permiten visitantes que tengan un problema de salud.",
  securityRule9: "No se permiten visitantes que tengan alguna discapacidad.",
  securityRule10:
    "No se permiten visitantes que tengan un problema de conducta o que no cumplan los siguientes requisitos:",
  goodPracticesTitle: "BUENAS PRÁCTICAS DE MANUFACTURA Y CÓDIGO DE VESTIMENTA",
  goodPractices1:
    "Prohibido el uso de ropa inapropiada como tops sin mangas, escotes, shorts, pantalones rotos o rasgados. El pantalón debe cubrir completamente la pierna.",
  goodPractices2:
    "Prohibido el uso de zapatos abiertos o con tacones en áreas operativas.",
  goodPractices3: "Consumir alimentos y bebidas solo en las áreas designadas.",
  goodPractices4: "Mantener el área de trabajo ordenada y limpia.",
  goodPractices5:
    "Usar el cabello corto o recogido, y no portar cadenas, anillos, pulseras u otros objetos que puedan atraparse en las áreas operativas.",
  prohibitedItemsTitle: "ARTÍCULOS PROHIBIDOS",
  prohibitedItems1: "Bebidas alcohólicas.",
  purchaseOrder: "Orden de compra",
  letterContribute: "Carta porte",
  prohibitedItems2: "Narcóticos o sustancias controladas.",
  prohibitedItems3: "Explosivos.",
  prohibitedItems4: "Cigarrillos o productos de tabaco.",
  prohibitedItems5: "Armas de fuego o municiones.",
  prohibitedItems6: "Cámaras fotográficas o dedeo sin autorización.",
  prohibitedItems7:
    "Materiales peligrosos sin Hoja de Seguridad y autorización de HSE.",
  prohibitedItems8: "Cuchillas removibles.",
  prohibitedItems9:
    "Motores de combustión interna sin control de emisiones aprobado.",
  close: "Cerrar",
  vendors: "Proveedores",
  employees: "Empleados",
  visitants: "Visitantes",
  visitant_email: "Correo del visitante",
  visitant_phone: "Teléfono del visitante",
  drag_file: "Arrastre el archivo aquí",
  back: "Atrás",
  usernameOrEmail: "Nombre de usuario o correo electrónico",
  password: "Contraseña",
  rememberMe: "Recuérdame",
  forgotpassword: "¿Olvidaste tu contraseña?",
  login: "Iniciar sesión",
  vendorsAccess: "Acceso de proveedores",
  employeesAccess: "Acceso de empleados",
  visitantsAccess: "Acceso de visitantes",
  carriersAccess: "Acceso de transportistas",
  home: "Inicio",
  welcomeTo: "!Bienvenido a",
  resumeTwoDays: "Resumen de los dos días anteriores",
  toDate: "Hasta la fecha",
  rounds: "Rondas",
  findingsInTransit: "Hallazgo en tránsito",
  findingsOnPatrol: "Hallazgo en ronda",
  incidents: "Incidentes",
  incident: "Incidente",
  findings: "Hallazgos",
  reports: "Reportes",
  bill: "Factura",
  monthlyIncidentsReport: "Reporte de incidentes mensual",
  selectMonth: "Seleccionar mes",
  startDate: "Fecha inicial",
  endDate: "Fecha final",
  dateFrom: "Fecha - Desde",
  dateTo: "Fecha - Hasta",
  month: "Mes",
  year: "Año",
  download: "Descargar",
  unableToLoadReport: "No se pudo cargar el reporte",
  selectRound: "Seleccionar ronda",
  checkListReport: "Reporte de lista de verificación",
  all: "Todos",
  positive: "Positivo",
  neutral: "Neutral",
  negative: "Negativo",
  roundLogReport: "Bitácora de ronda",
  onlyCompleted: "Solo completados",
  onlyUncompleted: "Solo incompletos",
  onlyWithoutExecuted: "Solo no finalizados",
  opened: "Abierto",
  closed: "Cerrado",
  roundRoute: "Ruta de Ronda",
  tags: "Etiquetas",
  tasks: "Tareas",
  users: "Usuarios",
  administration: "Administración",
  permissions: "Permisos",
  roles: "Roles",
  search: "Buscar",
  export: "Exportar",
  exportCSV: "Exportar CSV",
  exportPDF: "Exportar PDF",
  finishedRounds: "Rondas finalizadas",
  OnGoingRounds: "Rondas en curso",
  route: "Ruta",
  realizedBy: "Realizado por",
  occurred: "Ocurrió",
  finished: "Finalizó",
  duration: "Duración",
  accomplishment: "Completado",
  view: "Ver",
  records: "Registros",
  noRecordsFound: "No se encontraron registros",
  of: "de",
  patrols: "Rondínes",
  rejectAccessRequestTitle: "Rechazar solicitud de acceso",
  writeTheRejectReason: "Escriba la razon del rechazo",
  accessrequests: "Solicitudes de acceso",
  newAccessRequest: "Nueva solicitud de acceso",
  newCarrierAccessRequest: "Nueva solicitud de acceso carrier",
  accessLog: "Bitácora de acceso",
  accessvip: "Accesos VIP",
  accesslogvip: "Bitácora de acceso VIP",
  Accesses: "Accesos",
  accountDetails: "Detalles de la cuenta",
  id: "ID",
  name: "Nombre",
  lastname: "Apellido",
  username: "Nombre de usuario",
  email: "Correo electrónico",
  mobile: "Teléfono",
  accountEdit: "Editar cuenta",
  changePassword: "Cambiar contraseña",
  loading: "Cargando...",
  report: "Reporte",
  enterName: "Ingrese el nombre",
  oldpassword: "Contraseña actual",
  newpassword: "Nueva contraseña",
  confirmpassword: "Confirmar contraseña",
  profileImage: "Imagen de perfil",
  enterLastname: "Ingrese el apellido",
  enterUsername: "Ingrese el nombre de usuario",
  enterEmail: "Ingrese el correo electrónico",
  enterMobile: "Ingrese el teléfono",
  requestCannotBeCompleted: "La solicitud no puede ser completada",
  all_rights_reserved: "Todos los derechos reservados",
  myAccount: "Mi cuenta",
  logout: "Cerrar sesión",
  welcome: "¡Bienvenido!",
  accesslog: "Bitácora de acceso",
  actions: "Acciones",
  downloadPDF: "Descargar PDF",
  addNew: "Agregar nuevo",
  enterLabel: "Ingrese la etiqueta",
  send: "Enviar",
  edit: "Editar",
  delete: "Eliminar",
  update: "Actualizar",
  requester: "Solicitante",
  select_a_value: "Seleccione un valor",
  vendor: "Proveedor",
  carrierCompany: "Empresa Transportista",
  carrierCompanies: "Empresas Transportistas",
  newCarrierCompany: "Nueva Empresa Transportista",
  editCarrierCompany: "Editar Empresa Transportista",
  viewCarrierCompany: "Ver Empresa Transportista",
  subject: "Asunto",
  enterSubject: "Ingrese el asunto",
  visitMessageRequest:
    "Este acceso es exclusivamente para visitas. Queda estrictamente prohibido realizar actividades operativas, tales como obras, construcción, mantenimiento o entrega de materiales bajo este tipo de permiso",
  visit_to: "Visita a",
  scheduledVisitDate: "Fecha de visita programada",
  requestDate: "Fecha de solicitud",
  identification: "Identificación",
  documentation: "Documentación",
  employee: "Empleado",
  fullNameVisitor: "Nombre completo del visitante",
  visitor: "Visitante",
  enterPhone: "Ingrese el teléfono",
  status: "Estado",
  priority: "Prioridad",
  addAccessrequest: "Agregar solicitud de acceso",
  expirationDate: "Fecha de expiración",
  exitTime: "Fecha y hora de salida",
  kanban: "Kanban",
  newRequest: "Nueva solicitud",
  requests: "Solicitudes",
  accessRequestStatus: "Estado de la solicitudes de acceso",
  date: "Fecha",
  selectDate: "Seleccionar fecha",
  dateRange: "Rango de fechas",
  comment: "Comentario",
  documentationQ: "¿Documentación?",
  noRequireRevision: "No requiere\nrevisión",
  documentationCorrect: "Documentación\ncorrecta",
  requireRevision: "Revisión\npara trabajos",
  acceptedQ: "¿Aceptado?",
  yes: "Sí",
  no: "No",
  Documentación: "Documentación",
  Validación: "Validación",
  Rechazado: "Rechazado",
  Aceptado: "Aceptado",
  Completado: "Completado",
  Invitado: "Invitado",
  add: "Agregar",
  host: "Host",
  enterCompany: "Ingrese la empresa",
  select_date: "Seleccione una fecha",
  taxId: "RFC",
  vendorStatus: "Estado del proveedor",
  repse: "REPSE",
  address: "Dirección",
  requesterDetails: "Detalles del solicitante",
  deleteRecord: "Eliminar registro",
  confirmRecordDeletion: "¿Seguro que quieres borrar este registro?",
  recordDeletedSuccessfully: "Registro eliminado con éxito",
  acceptVisit: "Aceptar visita",
  confirmAcceptVisit: "¿Seguro que quieres aceptar la visita?",
  acceptedSuccessfully: "Aceptado con éxito",
  rejectVisit: "Rechazar visita",
  rejectionReason: "Razón del rechazo",
  confirmRejectVisit: "¿Seguro que quieres rechazar la visita?",
  rejectedSuccessfully: "Rechazado con éxito",
  date_hour: "Fecha y hora",
  dateCreated: "Fecha de creación",
  type: "Tipo",
  securityGuard: "Guardia de seguridad",
  accessNotes: "Notas de acceso",
  notes: "Notas",
  gaveAccess: "Dió acceso",
  images: "Imagenes",
  qrCode: "Código QR",
  viewQr: "Ver QR",
  notAvailable: "No disponible",
  enterTaxId: "Ingrese el RFC",
  checking: "Comprobando...",
  enterAddress: "Ingrese la dirección",
  formsRequired: "Formularios requeridos",
  formValidationError: "El formulario no es válido",
  formValidationMsg: "Por favor, complete los campos requeridos",
  createRecord: "Crear registro",
  createRecordSuccess: "Registro creado con éxito",
  category: "Categoría",
  updateRecord: "Actualizar registro",
  updateSuccess: "Registro actualizado con éxito",
  bitacora: "Bitácora de control",
  acceptCarrierRequest: "Aceptar solicitud carrier",
  rejectCarrierRequest: "Rechazar solicitud carrier",
  select_a_status: "Seleccione un estado",
  box: "Contenedor",
  box_number: "Número de caja",
  nss: "NSS",
  enterNss: "Ingrese el NSS",
  employeeDetails: "Detalles del empleado",
  forms: "Formularios",
  writeHere: "Escribir aquí",
  carrier: "Transportistas",
  carrierrequests: "Solicitudes de acceso carrier",
  searchCarrierRequest:
    "Buscar por empresa, chofer, contenedor o movimiento...",
  searchCarrierRequestHint:
    "Busca por: Nombre de empresa • Nombre de chofer • Número de contenedor • Tipo de movimiento",
  carriersAreas: "Áreas de Transportistas",
  carriersReceipt: "Área de Recibo",
  carriersYard: "Área de Yarda",
  carriersShipping: "Área de Embarques",
  carriersExports: "Exportaciones (México)",
  receiptAreaSubtitle: "Gestión de transportistas en área de recibo",
  yardAreaSubtitle: "Gestión de transportistas en área de yarda",
  shippingAreaSubtitle: "Gestión de transportistas en área de embarques",
  importsSubtitle: "Gestión de importaciones desde USA",
  exportsSubtitle: "Gestión de exportaciones hacia USA",
  importsList: "Listado de Importaciones",
  exportsList: "Listado de Exportaciones",
  olderDay: "Día anterior",
  newerDay: "Día siguiente",
  pickDate: "Ir a fecha",
  containerNumber: "Número de Contenedor",
  searchByContainer: "Buscar por número de contenedor",
  clearFilters: "Limpiar Filtros",
  exportToExcel: "Exportar a Excel",
  yardaOrigen: "Yarda de Origen",
  container: "Contenedor",
  tractorNumber: "Número de Tractor",
  driver: "Chofer",
  platesUSAMX: "Placas USA/MX",
  fechaSalidaYarda: "Fecha Salida de Yarda",
  horaSalidaYarda: "Hora Salida de Yarda",
  salidaAduanaMexicana: "Salida Aduana Mexicana",
  carreteraAeropuerto: "Carretera Aeropuerto",
  llegadaPlanta: "Llegada a Planta",
  numeroCandado: "Número de Candado",
  numeroSello: "Número de Sello",
  numeroSello2: "Número de Sello 2",
  numeroSelloRojo: "Número de Sello Rojo",
  numeroSelloAzul: "Número de Sello Azul",
  destinoFinal: "Destino Final",
  hora: "Hora",
  marca: "Marca",
  horaCarrAeropuerto: "Hora Carr. Aeropuerto",
  puntoInspeccion: "Punto de Inspección",
  horaAduanaMX: "Hora Aduana MX",
  horaCruce: "Hora Cruce",
  horaLlegadaYarda: "Hora Llegada a Yarda",
  yarda: "Yarda",
  aduanaMXUSA: "Aduana MX/USA",
  envioTicket: "Envío Ticket",
  envioCorreo: "Envío de Correo",
  evidenciaK9: "Evidencia Punto de Inspección K-9",
  historialGPS: "Historial GPS",
  goBack: "Volver",
  refreshData: "Actualizar datos",
  refresh: "Actualizar",
  rampsDashboards: "Dashboards de Andenes",
  carrier_accesslog: "Bitácora de acceso carrier",
  rampsScreen: "Pantalla de Andenes",
  settings: "Configuraciones",
  vendorsCategories: "Categorias de proveedores",
  departments: "Departamentos",
  priorities: "Prioridades",
  statusRequests: "Estado de las solicitudes",
  statusUsers: "Estado de los usuarios",
  statusVendors: "Estado de los proveedores",
  statusRepse: "Estado de REPSE",
  print: "Imprimir",
  pdf: "PDF",
  excel: "Excel",
  csv: "CSV",
  historyChanges: "Historial de cambios",
  noAuditsRecords: "No hay registros de auditoria",
  change: "Cambio",
  unknown: "Desconocido",
  inProgress: "En progreso",
  created: "Creado",
  updated: "Actualizado",
  deleted: "Eliminado",
  event: "Evento",
  findingReport: "Reporte de Hallazgo",
  findingType: "Tipo de Hallazgo",
  inTransit: "En tránsito",
  onPatrol: "En ronda",
  updating: "Actualizando...",
  changeToClosed: "Cambiar a cerrado",
  changeToOpened: "Cambiar a abierto",
  carrierrequests: "Listado de solicitudes carrier",
  tag: "Etiqueta",
  task: "Tarea",
  description: "Descripción",
  noImagesAttached: "No hay imagenes adjuntas",
  finishedAt: "FINALIZÓ A LAS",
  round: "Ronda",
  duration: "Duración",
  tagsCompleted: "Etiquetas completadas",
  successFinished: "Finalizado correctamente",
  earlyFinished: "Finalizado anticipadamente",
  notFinished: "No finalizado",
  folio: "Folio",
  doneBy: "Realizado por",
  hour: "Hora",
  comments: "Comentarios",
  user: "Usuario",
  addComment: "Agregar comentario",
  area: "Área",
  responsableOfService: "Responsable de servicio",
  itWasReported: "Se reporto",
  severity: "Severidad",
  shortDescription: "Descripción breve",
  incidentReport: "Reporte de incidente",
  reportDate: "Fecha de reporte",
  ocurrenceDate: "Fecha de ocurrencia",
  reportedBy: "Reportado por",
  deleteSelected: "Eliminar seleccionados",
  addTag: "Agregar etiqueta",
  seals: "Sellos",
  latitude: "Latitud",
  longitude: "Longitud",
  altitude: "Altitud",
  selectLocation: "Seleccionar ubicación",
  location: "Ubicación",
  drag_marker: "Arrastre el marcador para cambiar la ubicación",
  subcategory: "Subcategoría",
  group: "Grupo",
  keyword: "Palabra clave",
  task: "Tarea",
  enterPassword: "Ingrese la contraseña",
  confirmPassword: "Confirmar contraseña",
  department: "Departamento",
  role: "Rol",
  securityRulesHeader: "Normas de seguridad",
  scrollToAcceptSecurityRules:
    "Desplázate hasta el final para habilitar la aceptación.",
  errorLoadingPdf: "No se pudo cargar el PDF.",
  welcomeVip: "¡BIENVENIDO",
  seeYouSoonVip: "¡NOS VEMOS PRONTO",
  accessQrCodeQuestion: "¿Registrar ingreso con el código leído?",
  accessQrCodeError: "Hubo un error registrando el ingreso.",
  cameraNotFound: "Cámara no encontrada",
  cameraNotAccess: "No se puede acceder a la cámara",
  toggleCamera: "Cambiar camara",
  confirm: "Confirmar",
  appPatrol: "Aplicación de Rondínes",
  appGuard: "Aplicación de Guardía",
  appCarrier: "Aplicación de Kiosko para Carriers",
  modulePatrol: "Rondínes Resumen",
  moduleGuard: "Accesos Resumen",
  moduleCarrier: "Andenes Resumen",
  patrol: "Rondínes",
  guard: "Guardía",
  accessInsideBuilding: "Accesos dentro de planta",
  requestsToApprove: "Solicitudes por aprobar",
  vendorRequestsToApprove: "Solicitudes por aprobar de proveedores",
  approvedRequests: "Solicitudes aceptadas",
  vendorsList: "Padrón de Proveedores",
  monthlyRequests: "Solicitudes mensuales",
  exporting: "Exportando...",
  findingOnPatrol: "Hallazgos en ronda",
  findingInTransit: "Hallazgos en tránsito",
  occurrenceDate: "Fecha de ocurrencia",
  quizTitle: "Encuesta",
  answerQuiz: "Responder encuesta",
  notProhibited1: "Alimentos y bebidas",
  notProhibited2: "Celular y dispositivos electrónicos",
  notGoodPractices1: "Uso de ropa inapropiada y/o casual",
  question1: "¿Cuál es la primera regla de seguridad?",
  question2: "¿Qué está prohibido?",
  question3: "¿Cuál de las siguientes respuestas no es una buena prática?",
  errorQuiz: "Responde al menos 2 correctamente para continuar.",
  vehicles: "Vehículos",
  plates: "Placas",
  model: "Modelo",
  circulation_card: "Tarjeta de circulación",
  vehicle_secure: "Seguro de vehículo",
  enterPlates: "Ingrese las placas",
  enterModel: "Ingrese el modelo",
  select_year: "Seleccione el año",
  fk_vendor: "Proveedor",
  vehicle: "Vehículo",
  tracto: "Tracto",
  tractos: "Tractos",
  tools: "Herramientas",
  computers: "Computadoras",
  serial_number: "Número de serie",
  enterSerialNumber: "Ingrese el número de serie",
  computer_equipment: "Equipo de computo",
  files: "Archivos",
  employee_name: "Nombre de empleado",
  employee_number: "No. Empleado",
  driverLicense: "Licencia de Conducir",
  enterDriverLicense: "Ingrese el número de licencia",
  categoryServiceMessage:
    "Si la categoría del empleado es Servicios Especializados deberá subir los archivos de Seguro e ISO 14001 así como tener vigente Curso seguridad e higiene y Curso patrimonial.",
  categoryContractorMessage:
    "Si la categoría del empleado es Contratista deberá subir los archivos de Seguro así como tener vigente Curso seguridad e higiene y Curso patrimonial.",
  categoryVendorMessage:
    "Si la categoría del proveedor es Proveedor no necesita subir ningun archivo.",
  computer_id: "Equipo de computo",
  tools_id: "Herramientas",
  image: "Imagen",
  photo: "Fotografía",
  photoUploadHint: "Haz clic para seleccionar la fotografía",
  captcha_expiration_advisement:
    "¡Despues de validar el captcha cuenta con 5 minutos para realizar la solicitud de visita!.",
  captcha_advisement:
    "Verifique que no es un robot. Los robots no pueden acceder a la planta.",
  privacyNotice: "Aviso de privacidad",
  securityRules: "Normas de seguridad",
  youMustAcceptPrivacyNotice:
    "Debe aceptar y leer detalladamente el aviso de privacidad para estar de acuerdo con las normas de información así como el uso de su información personal.",
  youMustAcceptSecurityRules:
    "Debe aceptar y leer detalladamente las normas de seguridad de la planta.",
  acceptAndContinue: "Aceptar y continuar",
  employeeExpiredCoursesMessage:
    "El empleado tiene cursos vencidos y no debe tener acceso a las instalaciones.",
  blockedEmployeesMessage:
    "Los siguientes empleados no pueden ser seleccionados porque requieren que personal de Airlife cargue la documentación requerida para el acceso:",
  enabledEmployeesGroup: "Habilitados",
  blockedEmployeesGroup: "Pendiente: Airlife debe cargar documentación",
  pendingAirlifeDocumentation: "Documentación pendiente",
  areYouAForeigner: "¿Es usted extranjero?",
  accessType: "Tipo de acceso",
  date: "Fecha",
  switchLanguage: "Cambiar idioma",
  FM3RequiredToAccess:
    "Será necesario presentar el FM-3 para poder ingresar a la visita",
  other: "Otro",
  package_delivery: "Paqueteria",
  valuable_delivery: "Entrega de valores",
  employee_no_credential: "Personal sin gafete",
  staff_visit_exit: "Salida por visitas / alimentos",
  unregistered_overtime: "Tiempo extra no registrado",
  vehicle_entry_exit: "Ingreso de vehículos",
  guest: "Invitado",
  before: "Antes",
  after: "Después",
  empty: "Vacío",
  audits: {
    label: "Auditorias",
    descriptions: {
      employee:
        "El usuario ${userName} ${eventName} un empleado con el nombre ${employeeName}",
      employeeForm:
        "El usuario ${userName} ${eventName} una entrega del formulario ${formName} asignado a ${employeeName}",
      vendor:
        "El usuario ${userName} ${eventName} un proveedor con el nombre ${vendorName}",
      vehicle:
        "El usuario ${userName} ${eventName} un vehiculo modelo ${vehicleModel} del año ${vehicleYear}",
      tool: "El usuario ${userName} ${eventName} una herramienta llamada ${toolName}",
      computer:
        "El usuario ${userName} ${eventName} una computadora modelo ${computerModel} con serial ${computerSerialNumber}",
      task: "El usuario ${userName} ${eventName} una tarea con el nombre ${taskName}",
      tag: "El usuario ${userName} ${eventName} una etiqueta con el nombre ${tagName}",
      patrol:
        "El usuario ${userName} ${eventName} una ruta de ronda llamada ${patrolName}",
      incident:
        "El usuario ${userName} ${eventName} un incidente con el folio ${folio} en el area ${area} con descripcion '${shortDescription}'",
      finding:
        "El usuario ${userName} ${eventName} un hallazgo con el folio ${folio} con descripcion ${description}",
      findingWithTask:
        "El usuario ${userName} ${eventName} un hallazgo con el folio ${folio} para la tarea ${task} con descripcion ${description}",
      round:
        "El usuario ${userName} ${eventName} una ronda con el folio ${folio} para la ruta ${patrolName}",
      accessRequest:
        "El usuario ${userName} ${eventName} una solicitud de acceso de tipo ${accessType}. ${contactName} de ${companyName} visita a ${visitTo}",
      box: "El usuario ${userName} ${eventName} un contenedor de tipo ${containerType} con numero de caja ${boxNumber} de ${vendorName}",
      carrierVehicle:
        "El usuario ${userName} ${eventName} un tracto de ${affiliationLabel} con numero de unidad ${unitNumber} y tipo ${typeLabel}",
      carrierRequest:
        "El usuario ${userName} ${eventName} una solicitud de acceso de transportista de la compañia ${vendorName} para el dia ${date} con chofer ${driverName}, tracto ${vehicleUnitNumber} y estatus ${statusName}",
    },
    events: {
      created: "creó",
      updated: "modificó",
      deleted: "eliminó",
      restored: "restauró",
    },
    employeeFormTitle: "Formularios de empleados - Auditoria",
    employeeTitle: "Empleados - Auditoria",
    employeeCategoryTitle: "Categoria de empleados - Auditoria",
    vendorTitle: "Proveedores - Auditoria",
    toolTitle: "Herramientas - Auditoria",
    computerTitle: "Computadoras - Auditoria",
    vehicleTitle: "Vehiculos - Auditoria",
    taskTitle: "Tareas - Auditoria", // TODO: Refactor the titles to reduce duplication
    tagTitle: "Etiqueta - Auditorias",
    patrolTitle: "Ruta de ronda - Auditorias",
    incidentTitle: "Incidente - Auditorias",
    findingTitle: "Hallazgo - Auditorias",
    roundTitle: "Ronda - Auditorias",
    accessRequestTitle: "Solicitud de acceso - Auditoria",
  },
  action: "Acción",
  form: "Formulario",
  formField: "Campo",
  employeeForms: "Formularios de empleados",
  response: "Repuesta",
  formSubmission: "Entrega de formulario",
  employeeCategories: "Categoria de empleados",
  employeeCategory: "Categoria de empleado",
  tool: "Herramienta",
  involvedPeople: "Personas involucradas",
  start: "Inicio",
  end: "Final",
  completionPercentage: "Porcentaje de compleción",
  emailToVisit: "Correo electronico del anfitrión",
  isForeigner: "Es extranjero",
  badge: "Gafete",
  vehicleInformation: "Información vehicular",
  accessRequest: "Solicitud de acceso",
  employeeForm: "Formulario de empleado",
  finding: "Hallazgo",
  acceptedSecurityRules: "Comprendió las normas de Seguridad",
  grantAll: "Dar todos",
  revokeAll: "Remover todos",
  searchPermissions: "Buscar permisos",
  Inspection: {
    singular: "Inspecciones",
    plural: "Inspecciones",
    requestId: "ID Solicitud",
    driverName: "Nombre del chofer",
    company: "Empresa",
    movement: "Movimiento",
    vehicleType: "Tipo de vehículo",
    unit: "Unidad",
    start: "Inicio de inspección",
    end: "Fin de inspección",
    guard: "Guardia",
    result: "Resultado de inspección",
    box_number: "Número de caja",
  },
  driver: "Conductor",
  carrierEconomic: "Económico tracto camión",
  boxEconomic: "Económico contenedor",
  eco_box_1: "Economico contenedor 1",
  eco_box_2: "Economico contenedor 2",
  documents: "Documentos",
  affiliation: "Affiliación",
  unitNumber: "Número de unidad",
  assetCheckouts: {
    title: "Salida de activos",
    status: {
      exited: "Salida registrada",
      waitingAuth: "Pendiente de autorización",
      notExited: "Sin salida",
      cannotReturn: "Esperando autorización/salida",
      awaitingExit: "Esperando salida",
      pendingReturn: "Pendiente de retorno",
    },
    dashboardTitle: "Dashboard de salidas de activos",
    dashboardSubtitle: "Indicadores clave de activos fuera del sitio",
    viewList: "Ver listado",
    airlifeAssignments: "Asignados a Airlife",
    recentActiveTitle: "Salidas activas",
    recentActiveSubtitle: "Últimas salidas con activos aún fuera",
    type: "Tipo de salida",
    types: {
      loan: "Prestamo",
      repair: "Reparación",
      owner: "Dueño de producto",
      supplier_sample: "Muestra a proveedor",
      donation: "Donación",
      sale: "Venta",
      return: "Devolución",
    },
    exitTime: "Fecha y hora de salida",
    company: "Compañia",
    employee: "Empleado",
    assets: "Activos",
    asset: "Activo",
    partNumber: "Número de parte",
    authorizers: {
      product_owner: "Dueño de producto",
      authorizer: "Quien autoriza",
      authorizerEmail: "Correo de quien autoriza",
      customs: "Aduanas",
      patrimonial_security: "Seguridad patrimonial",
      maintenance_superintendent: "Super Intendente de Mantenimiento",
      safety_hygiene: "Seguridad e higiene",
      finance: "Finanzas",
    },
    metrics: {
      active: "Salidas activas",
      activeHelper: "Con activos fuera del sitio",
      checkoutByType: "Salidas por tipo",
      checkoutByTypeHelper: "Desglose de tipos de salida activos",
      itemsOut: "Artículos sin retorno",
      itemsOutHelper: "Aún sin devolver",
      airlifeActive: "Activos con empleados de airlife",
      airlifeHelper: "Salidas de personal interno",
      vendorActive: "Activos con empleados de proveedores",
      vendorHelper: "Salidas de proveedores",
      pendingAuth: "Pendientes por autorizar",
      pendingHelper: "Esperando autorización antes de salir",
      vendorExits: "Pases de salida activos de tercero",
      vendorExitsHelper: "Listado por proveedor de pases",
      overdue: "Vencidos",
      overdueHelper: "Expirados con activos fuera",
      expiringHelper: "Próximos a expirar (3 días)",
      total: "Salidas totales",
      totalHelper: "Todos los registros",
      outstanding: "Activos fuera",
      rejected: "Rechazados",
      rejectedHelper: "Solicitudes denegadas",
    },
    metrics: {
      active: "Salidas activas",
      activeHelper: "Con activos fuera del sitio",
      checkoutByType: "Salidas por tipo",
      checkoutByTypeHelper: "Desglose de tipos de salida activos",
      itemsOut: "Activos fuera",
      itemsOutHelper: "Aún sin devolver",
      airlifeActive: "Activos con empleados de airlife",
      airlifeHelper: "Salidas de personal interno",
      vendorActive: "Activos con empleados de proveedores",
      vendorHelper: "Salidas de proveedores",
      pendingAuth: "Pendientes por autorizar",
      pendingHelper: "Esperando autorización antes de salir",
      vendorExits: "Pases de salida activos de tercero",
      vendorExitsHelper: "Listado por proveedor de pases",
      overdue: "Vencidos",
      overdueHelper: "Expirados con activos fuera",
      expiringHelper: "Próximos a expirar (3 días)",
      total: "Salidas totales",
      totalHelper: "Todos los registros",
      outstanding: "Activos fuera",
      rejected: "Rechazados",
      rejectedHelper: "Solicitudes denegadas",
    },
    metrics: {
      active: "Salidas activas",
      activeHelper: "Con activos fuera del sitio",
      checkoutByType: "Salidas por tipo",
      checkoutByTypeHelper: "Desglose de tipos de salida activos",
      itemsOut: "Activos fuera",
      itemsOutHelper: "Aún sin devolver",
      airlifeActive: "Activos con empleados de airlife",
      airlifeHelper: "Salidas de personal interno",
      vendorActive: "Activos con empleados de proveedores",
      vendorHelper: "Salidas de proveedores",
      pendingAuth: "Pendientes por autorizar",
      pendingHelper: "Esperando autorización antes de salir",
      vendorExits: "Pases de salida activos de tercero",
      vendorExitsHelper: "Listado por proveedor de pases",
      overdue: "Vencidos",
      overdueHelper: "Expirados con activos fuera",
      expiringHelper: "Próximos a expirar (3 días)",
      total: "Salidas totales",
      totalHelper: "Todos los registros",
      outstanding: "Activos fuera",
      rejected: "Rechazados",
      rejectedHelper: "Solicitudes denegadas",
    },
    overdue: "VENCIDO",
    expiredOn: "Venció el",
    expiresShort: "Vence",
  },
  return: "Retorno",
  returned: "Retornado",
  pendingReturn: "Pendiente de Retorno",
  returnedAt: "Retornado en",
  signature: "Firma",
  turn: "Turno",
  picture: "Imagen",
  document: "Documento",
  changeSignature: "Cambiar firma",
  boxNumber: "Número de contenedor",
  measures: "Medidas",
  currentSeal: "Último sellado",
  sealHistory: "Historial de sellados",
  noSealHistoryFound: "No hay historial de sellados para este contenedor",
  boxes: "Contenedores",
  economics: "Económicos",
  economicNumber: "Económico",
  boxEconomics: "Económicos de contenedor",
  carrierEconomics: "Económicos de transportista",
  twoMovements: "¿Dos movimientos?",
  movements: "Movimientos",
  firstMovement: "Primer movimiento",
  secondMovement: "Segundo movimiento",
  productOwner: "Dueño del producto",
  productOwnerEmail: "Correo electrónico del dueño del producto",
  authorizer: "Quien autoriza",
  authorizerEmail: "Correo de quien autoriza",
  patrimonialSecurity: "Seguridad patrimonial",
  customs: "Aduana",
  maintenanceSuperintendent: "Super Intendente de Mantenimiento",
  safetyHygiene: "Seguridad e higiene",
  finance: "Finanzas",
  authorization: "Autorización",
  requester: "Solicitante",
  authorize: "Autorizar",
  deny: "Denegar",
  denyAuthorization: "Denegar Autorización",
  denyReason: "Razón de la denegación",
  enterDenyReason: "Ingresa la razón para denegar esta autorización...",
  confirmAuthorization: "Confirmar Autorización",
  confirmAuthorizeMessage:
    "¿Estás seguro de que deseas autorizar esta salida de activos?",
  confirm: "Confirmar",
  pending: "Pendiente",
  authorized: "Autorizado",
  denied: "Denegado",
  exit: "Salida",
  return: "Retorno",
  sku: "SKU",
  partNumber: "Número de Parte",
  title: "Titulo",
  // Carriers - Imports & Exports & Locals
  carrierTracking: "Seguimientos",
  carriersImports: "Importaciones",
  carriersExports: "Exportaciones",
  carriersLocals: "Locales",
  massReports: "Reportes Masivos",
  massReportsSubtitle: "Generación de reportes de seguimientos por periodo",
  reportConfig: "Configuración del Reporte",
  optional: "Opcional",
  selectValidDateRange: "Por favor seleccione un rango de fechas válido",
  reportGeneratedSuccess: "Reporte masivo en ${format} generado correctamente",
  reportGenerationError: "Ocurrió un problema al generar el reporte",
  importsSubtitle: "Gestión de importaciones",
  exportsSubtitle: "Gestión de exportaciones",
  localsSubtitle: "Gestión de locales",
  importsList: "Lista de Importaciones",
  exportsList: "Lista de Exportaciones",
  olderDay: "Día anterior",
  newerDay: "Día siguiente",
  pickDate: "Ir a fecha",
  containerNumber: "Número de Contenedor",
  searchByContainer: "Buscar por contenedor",
  export: "Exportar",
  exportCSV: "Exportar CSV",
  exportPDF: "Exportar PDF",
  exportToExcel: "Exportar a Excel",
  filters: "Filtros",
  clearFilters: "Limpiar Filtros",
  filtered: "Filtrados",
  default: "Mes actual",
  from: "Desde",
  to: "Hasta",
  // Imports columns
  yardaOrigen: "Yarda Origen",
  container: "Contenedor",
  tractorNumber: "Número de Tractor",
  driver: "Chofer",
  platesUSAMX: "Placas USA/MX",
  fechaSalidaYarda: "Fecha Salida Yarda",
  horaSalidaYarda: "Hora Salida Yarda",
  cruceMexicana: "Llegada a aduana Americana",
  salidaAduanaMexicana: "Salida Aduana Mexicana",
  carreteraAeropuerto: "Carretera/Aeropuerto",
  llegadaPlanta: "Llegada Planta",
  numeroCandado: "Número Candado",
  numeroSello: "Número Sello",
  destinoFinal: "Destino Final",
  // Exports columns
  hora: "Hora",
  contenedor: "Contenedor",
  numTractor: "Núm. Tractor",
  chofer: "Chofer",
  transportista: "Transportista",
  salidaPlanta: "Salida Planta",
  cruzandoUSA: "Cruzando USA",
  llegadaYarda: "Llegada Yarda",
  descargadoYarda: "Descargado Yarda",
  retornoSP: "Retorno S/P",
  llegadaSanIsidro: "Llegada San Isidro",
  carreteraRetornoSPUSA: "Carretera Retorno S/P USA",
  salidaAduanaUSA: "Salida Aduana USA",
  enPlantaLleno: "En Planta Lleno",
  cargadoEnPlanta: "Cargado en Planta",
  inspeccionVacio: "Inspección Vacío",
  recibidoSinContenedor: "Recibido sin Contenedor",
  listoCarga: "Listo Carga",
  turnoCarga: "Turno Carga",
  candado: "Candado",
  sello: "Sello",
  boxLogs: "Bitácora de cajas",
  sealLogs: "Bitácora de sellos",
  carrierRequestLogbook: "Bitácora de solicitudes carrier",
  logId: "ID bitácora",
  carrierRequestIdLabel: "ID solicitud",
  dateTime: "Fecha / Hora",
  dateRange: "Rango de fechas",
  searchPlaceholder: "Buscar...",
  eventDescription: "Descripción del evento",
  recordsRange: "Registros ${from} - ${to} de ${total}",
  carrierStatus: {
    requested: "Solicitado",
    accepted: "Aceptado",
    rejected: "Rechazado",
    inspected: "Inspeccionado",
    "in-progress": "En progreso",
    sealed: "Sellado",
    finished: "Finalizado",
  },
  // Document statuses
  documentStatuses: {
    valid: "Vigentes",
    warning: "Por vencer",
    danger: "Próximo a vencer",
    expired: "Vencidos",
  },
  documentsTotalLabel: "Total",
  documentsEmpty: "Sin documentos registrados",
  documentsSection: "Documentos",
  expandDocuments: "Expandir",
  collapseDocuments: "Contraer",
  documentFieldTypes: {
    file: "Archivo",
    image: "Imagen",
    text: "Texto",
  },
  documentExpiredDays: {
    expired: "Vencido hace %d días",
    expiredToday: "Vence hoy",
    expiredTomorrow: "Vence mañana",
    expiredIn: "Vence en %d días",
    expiredInMonths: "Vence en %d meses",
  },
  employeeCategories: "Categoría",
  employeeCompany: "Empresa",
  // Carrier requests view labels
  requestDate: "Fecha Solicitud",
  requestStatus: "Estado",
  vehicleType: "Tipo Vehículo",
  unitNumber: "Número de Unidad",
  platesUSA: "Placas USA",
  platesMX: "Placas MX",
  driverName: "Nombre",
  driverLicenseLabel: "Licencia de Conducir",
  driverCategory: "Categoría",
  driverPhoto: "Fotografía",
  noPhoto: "Sin fotografía",
  driverData: "Datos del Chofer",
  tractData: "Datos del Tracto",
  requesterData: "Datos del Solicitante",
  movements: "Movimientos",
  firstMovement: "Primer Movimiento",
  secondMovement: "Segundo Movimiento",
  userData: "Usuario",
  userFirstNames: "Nombres",
  userLastName: "Apellido",
  userEmail: "Email",
  userPhone: "Teléfono",
  timeline: "Línea de tiempo",
  seeImage: "Ver imagen",
  viewSealing: "Ver sellado",
  sealingDetails: "Detalle de sellado",
  sealingPhotos: "Fotos del proceso",
  signatures: "Firmas",
  notAvailable: "No disponible",
  noSignature: "Sin firma",
  sealedAt: "Hora de sellado",
  sealedBy: "Sellado por",
  vvttLabel: "VVTT",
  finalObservations: "Observaciones finales",
  doorsClosed: "Puertas cerradas",
  doorsOpen: "Puertas abiertas",
  sealPlacement: "Colocación de sello",
  bottleSeal: "Sello botella",
  chicoteSeal: "Sello chicote",
  redSeal: "Sello rojo",
  doorsClosedWithSeal: "Puertas cerradas con sello",
  signatureDriver: "Firma del transportista",
  signatureSealer: "Firma del sellador",
  signatureGuard: "Firma del guardia",
  noSealingFound: "No hay sellado registrado",
  noLogsFound: "No hay registros",
  carrierRequestDetail: "Detalle de solicitud",
  deleteRecord: "Eliminar el registro",
  confirmRecordDeletion: "¿Seguro que quieres borrar este registro?",
  recordDeletedSuccessfully: "Grabar eliminado con éxito",
  transportista: "Transportista",
  currentSeal: "Último sellado",
  deleteSelected: "Eliminar seleccionado",
  noSealAssigned: "Sin sellado registrado",
  requiredDocuments: "Documentos Requeridos",
  completeDocumentationInfo:
    "Complete la información de los documentos requeridos para esta categoría de transportista.",
  futureDate: "Fecha futura requerida",
  loadingDocuments: "Cargando documentos requeridos...",
  documentsLoaded: "Documentos Cargados",
  noDocumentsFound: "No se encontraron documentos para esta categoría",
  errorLoadingDocuments: "Error al Cargar Documentos",
  unexpectedServerResponse:
    "El empleado se actualizó pero la respuesta del servidor fue inesperada",
  departmentUsers: "Usuarios del departamento",
  usersInDepartment: "Usuarios en este departamento",
  noUsersInDepartment: "No hay usuarios en este departamento",
  usersDepartment: "Departamentos",
  expandUsers: "Ver usuarios",
  collapseUsers: "Ocultar usuarios",
  totalUsersInDepartment: "Total de usuarios",
  userActive: "Usuario activo",
  userInactive: "Usuario inactivo",
  archiveRecords: "Registros",
  isLoadedLabel: "¿Vehículo cargado?",
  isLoadedTarimasLabel: "¿Con tarimas?",
  isLoadedMaterialLabel: "¿Con material?",
  isLoadedYes: "Sí (Cargado)",
  isLoadedNo: "No (Vacío)",
  isLoadedHint: "Solo aplica para trailer en entrada importación o local.",
  isExportLabel: "¿Salida con caja vacía es exportación?",
  isExportYes: "Sí (Exportación)",
  isExportNo: "No (Nacional)",
  isExportHint:
    "Solo aplica cuando el segundo movimiento es salida con caja vacía.",
  twoMovementsLabel: "Programar salida posterior",
  twoMovementsHint: "Activa si habrá un segundo movimiento de salida.",
  entranceMovementHint: "Los movimientos de entrada solo se seleccionan aquí.",
  exitMovementHint: "Los movimientos de salida se seleccionan solo aquí.",
  selectMovement: "Seleccione un movimiento",
  carrierDataTitle: "Datos del transportista",
  carrierDataSubtitle: "Empresa, operador y unidad para validar el acceso.",
  movementsDataTitle: "Movimientos y carga",
  movementsDataSubtitle:
    "El primer movimiento define el checklist de inspección.",
  schedulingTitle: "Programación",
  schedulingSubtitle: "Selecciona fecha disponible y estatus de la solicitud.",
  step1: "Paso 1",
  step2: "Paso 2",
  step3: "Paso 3",
  solicitante: "Solicitante",
  carrierCompanyPlaceholder: "Seleccione una empresa transportista",
  companyDefinesOperators:
    "La empresa define el catálogo de operadores y unidades.",
  selectCompanyFirst: "Primero seleccione una empresa transportista",
  selectVehicleFirst: "Primero seleccione un vehículo",
  driverResponsible: "Selecciona al operador responsable de la unidad.",
  vehicleTypeHint: "El tipo de vehículo define los puntos de inspección.",
  containerFirstMovement: "Contenedor asignado al primer movimiento.",
  containerSecondMovement: "Contenedor asignado al segundo movimiento.",
  selectOption: "Selecciona una opción",
  loadingAvailability: "Cargando disponibilidad...",
  scheduledCarrierDate: "Fecha programada de carrier",
  available: "Disponible",
  limited: "Limitado",
  unavailable: "No disponible",
  statusHint: "Define el estado inicial de la solicitud.",
  confirmVisitDate: "Confirma la fecha de visita programada.",
  adjustVisitDate: "Ajusta fecha y estatus de la solicitud.",

  // Employee No Credential Translations
  employeeInfo: "Información del Empleado",
  employeeNumber: "Número de Empleado",
  area: "Área",
  supervisor: "Supervisor",
  badgeNumber: "Número de Gafete",
  deliveryTime: "Hora de Entrega",
  motivo: "Motivo",
  accessNotes: "Notas de Acceso",

  // Visit Approvers
  visitApprovers: "Aprobadores de Visita",
  addApprover: "Agregar Aprobador",
  removeApprover: "Eliminar Aprobador",
  noApproversFound: "No hay aprobadores registrados",
  approverAdded: "Aprobador agregado correctamente",
  approverRemoved: "Aprobador eliminado correctamente",
  addedOn: "Fecha de alta",
  selectUser: "Selecciona un usuario",

  carrierVehicle: "Tractos",
  carrierRequest: "Solicitudes de carrier"
};
